import { APPLE_STORE } from "app/pages/app-intelligence/constants";
import { getIsNewEngagementIosMetrics } from "app/pages/app-intelligence/helpers";

export const AppEngagementDailyActiveUsersIos = {
    id: "AppEngagementDailyActiveUsersIos",
    properties: {
        dashboard: "true",
        title: "metric.AppUsersEngagementDailyActiveUsers.title",
        family: "Mobile",
        component: "AppEngagementUserActivityIOS",
        state: "digitalsuite_app_usersengagement",
        apiController: "AppEngagementOverview",
        apiParams: {
            metric: "AppEngagementUserActivity",
            granularity: "Daily",
        },
        availabilityComponent: "WsAppEngagement",
        isHidden: () => !getIsNewEngagementIosMetrics(),
        options: {
            deviceFilteringUnavailable: true,
        },
    },
    widgets: {
        single: {
            defaultType: "AppEngagementMetricsDashboardGraph",
            AppEngagementMetricsDashboardGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                        noBottomPadding: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "apps.engagementoverview.tabs.activeusers.title",
                    type: "double?",
                    format: "abbrNumberVisits",
                    name: "DailyActiveUsers",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "AppEngagementMetricsDashboardGraph",
            AppEngagementMetricsDashboardGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                        noBottomPadding: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "apps.engagementoverview.tabs.activeusers.title",
                    type: "double?",
                    format: "abbrNumberVisits",
                    name: "DailyActiveUsers",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};

export const AppEngagementUserOverviewIos = {
    id: "AppEngagementUserOverviewIos",
    properties: {
        family: "Mobile",
        component: "AppEngagementUserActivityIOS",
        order: "1",
        state: "digitalsuite_app_usersengagement",
        dashboard: "true",
        title: "apps.usage.dashboardWidget.AppEngagementUserOverviewIOS.title",
        apiController: "AppEngagementOverview",
        compareOnly: "true",
        iosOnly: "true",
        isHidden: () => !getIsNewEngagementIosMetrics(),
        availabilityComponent: "WsAppEngagement",
        apiParams: {
            metric: "AppEngagementUserActivity",
        },
        options: {
            deviceFilteringUnavailable: true,
        },
    },
    widgets: {
        single: {},
        compare: {
            defaultType: "AppEngagementOverviewTableIos",
            AppEngagementOverviewTableIos: {
                properties: {
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
            },
        },
    },
};

export const AppEngagementMonthlyActiveUsersIos = {
    id: "AppEngagementMonthlyActiveUsersIos",
    properties: {
        dashboard: "true",
        title: "metric.AppEngagementMonthlyActiveUsers.title",
        family: "Mobile",
        iosOnly: "true",
        component: "AppEngagementUserActivityIOS",
        state: "digitalsuite_app_usersengagement",
        apiController: "AppEngagementOverview",
        apiParams: {
            metric: "AppEngagementUserActivity",
            granularity: "Monthly",
        },
        availabilityComponent: "WsAppEngagement",
        isHidden: () => !getIsNewEngagementIosMetrics(),
        options: {
            deviceFilteringUnavailable: true,
        },
    },
    widgets: {
        single: {
            defaultType: "AppEngagementMetricsDashboardGraph",
            AppEngagementMetricsDashboardGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "apps.engagementoverview.tabs.activeusers.title",
                    type: "double?",
                    format: "abbrNumberVisits",
                    name: "MonthlyActiveUsers",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "AppEngagementMetricsDashboardGraph",
            AppEngagementMetricsDashboardGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "apps.engagementoverview.tabs.activeusers.title",
                    type: "double?",
                    format: "abbrNumberVisits",
                    name: "MonthlyActiveUsers",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};

export const AppEngagementWeeklyActiveUsers = {
    id: "AppEngagementWeeklyActiveUsers",
    properties: {
        dashboard: "true",
        title: "metric.AppEngagementWeeklyActiveUsers.title",
        family: "Mobile",
        component: "AppEngagementOverview",
        componentFunction: ({ key }) =>
            key[0]?.store === APPLE_STORE.toLocaleLowerCase() ? "AppEngagementUserActivity" : "AppEngagementOverview",
        state: "digitalsuite_app_usersengagement",
        apiController: "AppEngagementOverview",
        apiParams: {
            metric: "AppEngagementUserOverview",
            granularity: "Weekly",
            timeGranularity: "Weekly",
        },
        availabilityComponent: "WsAppEngagement",
        isHidden: () => !getIsNewEngagementIosMetrics(),
        options: {
            deviceFilteringUnavailable: true,
        },
    },
    widgets: {
        single: {
            defaultType: "AppEngagementMetricsDashboardGraph",
            AppEngagementMetricsDashboardGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "apps.engagementoverview.tabs.activeusers.title",
                    type: "double?",
                    format: "abbrNumberVisits",
                    name: "WeeklyActiveUsers",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "AppEngagementMetricsDashboardGraph",
            AppEngagementMetricsDashboardGraph: {
                properties: {
                    hideMarkersOnDaily: true,
                    options: {
                        showLegend: false,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "apps.engagementoverview.tabs.activeusers.title",
                    type: "double?",
                    format: "abbrNumberVisits",
                    name: "WeeklyActiveUsers",
                    reversed: "False",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                    ],
                },
            },
        },
    },
};
